import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

const RATE_LIMIT_STATUS = 429;
const RATE_LIMIT_RESET_HEADER = 'RateLimit-Reset';
const DEFAULT_RETRY_SECONDS = 1;

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retry({
                delay: (error: HttpErrorResponse) => {
                    if (!error || error.status !== RATE_LIMIT_STATUS || request.url.includes('/api/v1/media')) {
                        return throwError(() => error);
                    }

                    const resetHeader = error.headers.get(RATE_LIMIT_RESET_HEADER);
                    const retryAfterMs = (resetHeader ? parseInt(resetHeader, 10) : DEFAULT_RETRY_SECONDS) * 1000;

                    return timer(retryAfterMs);
                }
            })
        );
    }
}
